import { SectionDetails } from '@/app/types/marketing/SectionDetails';
import FeatureLandingPage from '@/components/feature-landing-page/FeatureLandingPage';

import {
  WrenchIcon,
  AcademicCapIcon,
  ArrowUpOnSquareStackIcon,
  BoltIcon,
  ChartBarIcon,
  ChatBubbleBottomCenterIcon,
  PencilIcon,
  PlayCircleIcon,
  DocumentDuplicateIcon
} from '@heroicons/react/24/solid';
import heroImage from '@/public/ai-practice-test-hero.png';
import overviewImage from '@/public/ai-practice-tests-overview.png';
import tutorialImage from '@/public/ai-practice-test-tutorial.png';

const overviewSection: SectionDetails = {
  miniText: 'Be Test Ready',
  title: 'Go into every exam with confidence',
  image: overviewImage,
  description:
    'Combine all of your pdfs, presentations and notes into a comprehensive practice test. Get a full score report and study tips with every test.',
  features: [
    {
      name: 'Combine multiple files.',
      description:
        'Combine all of your uploads into a single practice test.  No need to study each of your files individually.',
      icon: DocumentDuplicateIcon
    },
    {
      name: 'View score report.',
      description:
        'Get a full score report after each test showing your percent correct and the number of questions you got wrong.',
      icon: ChartBarIcon
    },
    {
      name: 'Set a target score.',
      description:
        'Set a passing target score for every test to ensure you have the confidence you need going into your exams.',
      icon: AcademicCapIcon
    },
    {
      name: 'Get study tips.',
      description:
        'Fill any knowledge gaps using automatically generated study available for every question you got wrong.',
      icon: PencilIcon
    },
    {
      name: 'Question Manipulation.',
      description:
        'Re-word or increase the difficulty of your flashcards for a customized practice test experience.',
      icon: BoltIcon
    },
    {
      name: 'Hints and explanations.',
      description:
        'Get hints and explanations for every question to ensure you are on top of everything you need to know.',
      icon: ChatBubbleBottomCenterIcon
    }
  ]
};

const tutorialSection: SectionDetails = {
  miniText: 'Get started',
  title: 'How it works',
  image: tutorialImage,
  description:
    'Creating practice tests is easy and configurable to make sure you have the exactly what you need to prepare for exam day.',
  features: [
    {
      name: 'Upload your file(s).',
      description:
        'Upload all of your files and create flashcard decks which will be used for your practice tests.',
      icon: ArrowUpOnSquareStackIcon
    },
    {
      name: 'Configure your test.',
      description:
        'Choose the files you want to use, the number of questions, a target score and optionally enable question manipulation.',
      icon: WrenchIcon
    },
    {
      name: 'Begin your test.',
      description:
        'Click begin and start your test! Get a full score report and study tips when you are all done  .',
      icon: PlayCircleIcon
    }
  ]
};

export default function _PdfToFlashcards() {
  return (
    <FeatureLandingPage
      heroImage={heroImage}
      analyticsName="home_practice_tests"
      overviewSection={overviewSection}
      tutorialSection={tutorialSection}
      heroMiniTitle="AI Practice Tests"
      heroTitle="Generate full practice tests in seconds"
      heroImageUrl={'/ai-practice-test-hero.png'}
      heroDescription="Build practice tests from any file with Limbiks.  Get a complete score report with every test including study tips for the questions you got wrong."
    />
  );
}
